import { type TextTag, type TypographyType } from "src/models/types/common.types";

export const TextTagMap: Record<TypographyType, TextTag> = {
	"display-large": "h2",
	"display-medium": "h3",
	"display-small": "h4",
	"display-xsmall": "h4",
	"heading-xlarge": "h1",
	"heading-large": "h1",
	"heading-medium": "h2",
	"heading-small": "h3",
	"heading-xsmall": "h4",
	"heading-2xsmall": "h4",
	"body-lead": "p",
	"body-xlarge": "p",
	"body-large": "p",
	"body-medium": "p",
	"body-small": "p",
	"button-medium": "label",
	"button-small": "label",
};
